/* 17signals.com — theme.js (Phase-1 skeleton)
   Scope: UTM capture + persistence, scroll reveal, video lazy-load.
   Author: Kelly. No dependencies. */

(function () {
  "use strict";

  /* ---- UTM capture & persistence (the attribution backbone) ---- */
  var UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

  function captureUtm() {
    var params = new URLSearchParams(window.location.search);
    var found = false;
    UTM_KEYS.forEach(function (k) {
      var v = params.get(k);
      if (v) { try { localStorage.setItem("17s_" + k, v); } catch (e) {} found = true; }
    });
    return found;
  }

  function hydrateHiddenUtmFields() {
    // Any hidden input named like an UTM key (or a referrer field) gets filled,
    // so the value rides into the cart line-item properties / Calendly prefill.
    UTM_KEYS.forEach(function (k) {
      var stored = null;
      try { stored = localStorage.getItem("17s_" + k); } catch (e) {}
      if (!stored) return;
      document.querySelectorAll('input[name="' + k + '"], input[name="properties[' + k + ']"]').forEach(function (el) {
        el.value = stored;
      });
    });
    document.querySelectorAll('input[name="properties[referrer]"]').forEach(function (el) {
      if (!el.value) el.value = document.referrer || "direct";
    });
  }

  /* ---- Scroll reveal ---- */
  function initReveal() {
    var els = document.querySelectorAll("[data-reveal]");
    if (!("IntersectionObserver" in window) || !els.length) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Hero video: poster-first, lazy (IntersectionObserver), reduced-motion/save-data aware ----
     The poster <img> is the LCP element; the video src is attached only when in view, and never
     for reduced-motion / save-data / very slow links (poster stays). Supports art-directed sources
     (data-src-desktop / data-src-mobile) and a legacy single data-src, plus tap-to-unmute. */
  function initHeroVideo() {
    var vids = document.querySelectorAll("video[data-src], video[data-src-desktop]");
    if (!vids.length) return;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var conn = navigator.connection || {};
    var saveData = conn.saveData === true;
    var slow = typeof conn.downlink === "number" && conn.downlink < 1;
    vids.forEach(function (v) {
      function chosen() {
        if (v.dataset.srcDesktop || v.dataset.srcMobile) {
          return window.matchMedia("(min-width: 750px)").matches
            ? (v.dataset.srcDesktop || v.dataset.srcMobile)
            : (v.dataset.srcMobile || v.dataset.srcDesktop);
        }
        return v.getAttribute("data-src");
      }
      function attach() {
        var src = chosen();
        if (!src || v.src === src) return;
        v.src = src; v.load();
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      if (reduce || saveData || slow) return; // poster only — honor user intent
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { attach(); io.disconnect(); } });
        }, { rootMargin: "200px" });
        io.observe(v);
      } else { attach(); }
      var wrap = v.closest("[data-video]");
      var btn = wrap && wrap.querySelector("[data-unmute]");
      if (btn) {
        btn.hidden = false;
        btn.addEventListener("click", function () {
          v.muted = !v.muted;
          btn.setAttribute("aria-pressed", String(!v.muted));
          btn.textContent = v.muted ? "Tap to unmute" : "Mute";
          if (!v.muted && v.paused) v.play();
        });
      }
    });
  }

  /* ---- Mobile nav drawer ---- */
  function initNavDrawer() {
    var toggle = document.querySelector("[data-nav-toggle]");
    var drawer = document.getElementById("nav-drawer");
    var scrim = document.querySelector("[data-nav-scrim]");
    if (!toggle || !drawer || !scrim) return;

    function setOpen(open) {
      drawer.classList.toggle("is-open", open);
      scrim.classList.toggle("is-open", open);
      scrim.hidden = !open;
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      drawer.setAttribute("aria-hidden", open ? "false" : "true");
      document.documentElement.style.overflow = open ? "hidden" : "";
    }
    toggle.addEventListener("click", function () {
      setOpen(!drawer.classList.contains("is-open"));
    });
    scrim.addEventListener("click", function () { setOpen(false); });
    drawer.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () { setOpen(false); });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) setOpen(false);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    captureUtm();
    hydrateHiddenUtmFields();
    initReveal();
    initHeroVideo();
    initNavDrawer();
  });
})();
